import React from 'react'

const Widget = ({
  image,
  imageWidth,
  imageHeight,
  title,
  description,
  parallaxData
}) => {

    return (
        <div className="widget" {...parallaxData}>
            <div className="icon-wrap">
                <img
                    src={image}
                    width={imageWidth}
                    height={imageHeight}
                    alt="image description"
                />
            </div>
            <h3>{title}</h3>
            <p>{description}</p>
        </div>
    )
}

export default Widget



// WEBPACK FOOTER //
// ./src/components/Widget.js